var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full",staticStyle:{"box-sizing":"border-box","padding":"10px"}},[_c('vxe-grid',_vm._b({ref:_vm.moduleName+'_list',attrs:{"loading":_vm.loading},on:{"toolbar-button-click":_vm.toolbarButtonClickEvent}},'vxe-grid',_vm.gridOptions,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }